import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAllDataLabelVisibilityCheckbox, createBackgroundAccordionItem, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createChartSortFormat, createColumnDataColorsPicker, createColumnNameTextInput, createDataLabelBackgroundFormatter, createDataLabelFilterDropdown, createDataLabelFontFormatter, createDataLabelMaxLengthInput, createDataLabelNumericFilter, createDataLabelVisibilityCheckbox, createMaxDataPointsInput, createPieBorderFormatter, createPlotAreaBackgroundColorFormatter, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, } from '../schema-composer-utils/common-elements';
import { shouldHideDataLabelsAccordion, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createColumnDataColorsPicker(),
                                    createChartSortFormat(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createAggregationDropdown(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                    createColumnDataColorsPicker(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const dataLabelSettings = [
    createSection({
        children: [createAllDataLabelVisibilityCheckbox()],
        isChartProperty: true,
    }),
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        key: 'columnName',
                        isAnswerProperty: true,
                        runTimeProperties: {
                            header: 'TS_INPUT',
                        },
                        children: [
                            createDataLabelVisibilityCheckbox(),
                            createDataLabelFilterDropdown(),
                            createDataLabelNumericFilter(),
                            createDataLabelFontFormatter(),
                            createDataLabelMaxLengthInput(),
                            createDataLabelBackgroundFormatter(),
                        ],
                    }),
                ],
            }),
        ],
    }),
];
const displaySettings = [
    createSection({
        children: [createMaxDataPointsInput(), createPieBorderFormatter()],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createBackgroundAccordionItem([
                        createChartBackgroundColorFormatter(),
                        createPlotAreaBackgroundColorFormatter(),
                        createBackgroundImageEditor(),
                    ]),
                ],
            }),
        ],
    }),
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
export const pieChartSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.AXIS]: null,
    [ChartSettingsV2MenuItems.LEGEND]: null,
};
//# sourceMappingURL=pie-schema.js.map